import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import ApkLoanFeeService from "services/Setup/LoanOrigination/ApkLoanFee/ApkLoanFeeService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  apkLoanFeeList: [],
  refreshList: false,
  getPageSize: 0,
  getPageIndex: 0,
  getCount: 0,
  apkLoanEditFeeList: [],
  statusRespon: "",
  noApkFAS: "",
  creditStepKTA: null,
};

// 🔹 Tambah data
export const addApkLoanFeeSlice = createAsyncThunk(
  "apkLoanFee/addApkLoanFeeSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ApkLoanFeeService.addApkLoanFeeService(userInput);

      if (response.status === 200) {
        const { status, message: desc } = response.data;

        if (status === "Success") {
          notification.success({
            message: status,
            description: desc,
            duration: 3,
          });
        } else {
          notification.error({
            message: status,
            description: desc,
            duration: 3,
          });
        }

        return response.data;
      }

      const errorMsg = response?.data?.message || "Unexpected response!";
      notification.error({
        message: "Error",
        description: errorMsg,
        duration: 3,
      });

      return rejectWithValue(errorMsg);
    } catch (error) {
      const statusText = error?.response?.data?.message || "Unexpected error!";
      notification.error({
        message: "Error",
        description: statusText,
        duration: 3,
      });

      return rejectWithValue(statusText);
    }
  }
);

export const editApkLoanFeeSlice = createAsyncThunk(
  "apkLoanFee/editApkLoanFeeSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ApkLoanFeeService.editApkLoanFeeService(userInput);

      if (response.status === 200) {
        const { status, message: desc } = response.data;

        if (status === "Success") {
          notification.success({
            message: status,
            description: desc,
            duration: 3,
          });
        } else {
          notification.error({
            message: status,
            description: desc,
            duration: 3,
          });
        }

        return response.data;
      }

      const errorMsg = response?.data?.message || "Unexpected response!";
      notification.error({
        message: "Error",
        description: errorMsg,
        duration: 3,
      });

      return rejectWithValue(errorMsg);
    } catch (error) {
      const statusText = error?.response?.data?.message || "Unexpected error!";
      notification.error({
        message: "Error",
        description: statusText,
        duration: 3,
      });

      return rejectWithValue(statusText);
    }
  }
);

// 🔹 Ambil data
export const getAddApkLoanFeeSlice = createAsyncThunk(
  "apkLoanFee/getAddApkLoanFeeSlice",
  async (prospectid, { rejectWithValue }) => {
    try {
      const response = await ApkLoanFeeService.getAddApkLoanFeeService(
        prospectid
      );

      if (response.status === 200 && response.data) {
        return response.data;
      }

      const errorMsg = response?.data?.message || "Unexpected response!";
      // notification.error({
      //   message: "Error",
      //   description: errorMsg,
      //   duration: 3,
      // });

      return rejectWithValue(errorMsg);
    } catch (error) {
      const statusText = error?.response?.data?.message || "Unexpected error!";
      // notification.error({
      //   message: "Error",
      //   description: statusText,
      //   duration: 3,
      // });

      return rejectWithValue(statusText);
    }
  }
);
export const getEditApkLoanFeeSlice = createAsyncThunk(
  "apkLoanFee/getEditApkLoanFeeSlice",
  async (prospectid, { rejectWithValue }) => {
    try {
      const response = await ApkLoanFeeService.getEditApkLoanFeeService(
        prospectid
      );

      if (response.status === 200 && response.data) {
        return response.data;
      }

      const errorMsg = response?.data?.message || "Unexpected response!";
      // notification.error({
      //   message: "Error",
      //   description: errorMsg,
      //   duration: 3,
      // });

      return rejectWithValue(errorMsg);
    } catch (error) {
      const statusText = error?.response?.data?.message || "Unexpected error!";
      // notification.error({
      //   message: "Error",
      //   description: statusText,
      //   duration: 3,
      // });

      return rejectWithValue(statusText);
    }
  }
);

export const ApkLoanFeeSlice = createSlice({
  name: "apkLoanFee",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    resetStatusRespon: (state) => {
      state.statusRespon = "";
    },
    setCreditStepKTA: (state, action) => {
      state.creditStepKTA = action.payload;
    },
    resetRefreshList: (state) => {
      state.refreshList = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // 🔹 addApkLoanFee
      .addCase(addApkLoanFeeSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(addApkLoanFeeSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload?.message || "";
        state.refreshList = true;
        state.statusRespon = action.payload?.status || "";
      })
      .addCase(addApkLoanFeeSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload || {};
        state.showMessage = true;
        state.noApkFAS = "";
        state.statusRespon = "Error";
      })
      // 🔹 editApkLoanFeeSlice
      .addCase(editApkLoanFeeSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(editApkLoanFeeSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload?.message || "";
        state.refreshList = true;
        state.statusRespon = action.payload?.status || "";
      })
      .addCase(editApkLoanFeeSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload || {};
        state.showMessage = true;
        state.noApkFAS = "";
        state.statusRespon = "Error";
      })

      // 🔹 getAddApkLoanFeeSlice
      .addCase(getAddApkLoanFeeSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAddApkLoanFeeSlice.fulfilled, (state, action) => {
        console.log("apkLoanFeeList", action.payload);

        state.loading = false;
        state.apkLoanFeeList = action.payload || [];
        state.statusRespon = "Success";
      })
      .addCase(getAddApkLoanFeeSlice.rejected, (state, action) => {
        state.loading = false;
        state.apkLoanFeeList = [];
        state.statusRespon = "Error";
      })
      // 🔹 getEditApkLoanFeeSlice
      .addCase(getEditApkLoanFeeSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getEditApkLoanFeeSlice.fulfilled, (state, action) => {
        console.log("apkLoanFeeList", action.payload);

        state.loading = false;
        state.apkLoanEditFeeList = action.payload || [];
        state.statusRespon = "Success";
      })
      .addCase(getEditApkLoanFeeSlice.rejected, (state, action) => {
        state.loading = false;
        state.apkLoanEditFeeList = [];
        state.statusRespon = "Error";
      });
  },
});

export const {
  showNotification,
  hideNotification,
  showLoading,
  resetStatusRespon,
  setCreditStepKTA,
  resetRefreshList,
} = ApkLoanFeeSlice.actions;

export default ApkLoanFeeSlice.reducer;
